export const isValidEmail = (email) => (
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim())
);

export const isTestEmail = (email) => (
  email
  && email.endsWith('@ollaa.app')
  && import.meta.env.MODE !== 'production'
);

export const isEmailVerificationRequired = (user) => (
  user && !user.emailVerified && !isTestEmail(user.email)
);

export const isPasswordChangeRequired = (company) => (
  Boolean(company) && (company.passwordChangeRequired === true || Number(company.passwordChangeRequired) === 1)
);

export const isLoginRoute = (route) => route?.path?.startsWith('/login');

const PUBLIC_TOKEN_ROUTE_NAMES = new Set([
  'login.email-action',
  'pin-setup',
  'pin-disable',
  'owner-pin-setup',
]);

const KITCHEN_ROUTE_NAMES = new Set([
  'kitchen.queue',
  'kitchen.settings',
  'kitchen.setup',
  'kitchen.push-prompt',
  'kitchen.pin',
  'kitchen-invalid',
]);

export const isKitchenRoute = (route) => (
  KITCHEN_ROUTE_NAMES.has(route?.name)
  || String(route?.path || '').startsWith('/kueche')
);

export const isPublicTokenRoute = (route) => (
  PUBLIC_TOKEN_ROUTE_NAMES.has(route?.name)
);

export const isPartnerCheckoutReturnRoute = (route, router) => {
  if (!route?.query?.checkout && typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    if (!params.get('checkout')) return false;
    const path = String(route?.path || window.location.pathname || '');
    return /\/navigation\/(membership|highlights|partner|werbebudget|specials)/.test(path);
  }
  if (!route?.query?.checkout) return false;
  const routeNames = new Set([
    'navigation.membership',
    'navigation.highlights',
    'navigation.partner',
    'navigation.werbebudget',
    'navigation.specials',
  ]);
  if (routeNames.has(route?.name)) return true;
  const path = String(route?.path || '');
  return /\/navigation\/(membership|highlights|partner|werbebudget|specials)/.test(path);
};
